/* eslint-disable max-len */
import React from "react";
import { PetAvatars } from "../../../components";
import { IPetDetail } from "../../../components/PetAvatars/PetAvatars";
import { IUpdatePaymentMethod } from "../../../services/get-alerts/get-alerts.interface";
import { getAlertTypeConfig } from "./WellnessPlanUpdatePopUpModal";

interface IPetCard {
  petsName: string;
  expiredPetList: IUpdatePaymentMethod[];
}

const PetCard = ({ expiredPetList }: IPetCard) => {
  const mapPetDetails = (pets: IUpdatePaymentMethod[]): IPetDetail[] => {
    const petDetails: IPetDetail[] = pets.map((pet: IUpdatePaymentMethod) => {
      return {
        name: pet.petName,
        image: pet.image,
        id: pet.animalId,
      };
    });

    return petDetails;
  };

  return (
    <div className="w-full">
      <PetAvatars
        className="-mb-10 flex justify-center"
        height={85}
        width={85}
        maxVisible={3}
        petDetails={mapPetDetails(expiredPetList)} />

      <div className="bg-white py-3 px-6 mx-2 rounded-xl pt-11">
        <div className="flex flex-col items-center gap-3 text-center">
          <div className="font-semibold text-xl">
            {expiredPetList.length === 1 ?
              <div>
                {getAlertTypeConfig(expiredPetList[0].alertType).header(expiredPetList[0].petName)}
              </div>:
              <div>
                Your Payment Method May Need an Update
              </div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetCard
;
